import React from "react";
import useCompanyOrderCards from "./companyOrderCard-hook";
import { IOrderResponse } from "../../../../../../../../Interfaces/responseTypes";
import { OrderStatus } from "../../../../../../../../Interfaces/formValue-interfaces";
import { formatDate } from "../../../../../../../../Utilits/utilits";
import { PhoneIcon } from "../../../../../../../../Components/IconComponents";
import { OrderStatusBadge } from "../OrderStatus/statusBadge";
import styles from "./companyOrderCard.module.scss";

interface IProps {
  order: IOrderResponse;
  isNew?: boolean;
  currencySymbol: string,
  onSelect: (order: IOrderResponse) => void;
  onOpenStatusDialog: (order: IOrderResponse) => void
}

const CompanyOrderCard: React.FC<IProps> = ({ order, isNew, currencySymbol, onOpenStatusDialog, onSelect }) => {
  const orderParams = JSON.parse(order.order_parameters);
  const { getOrderCardContent } = useCompanyOrderCards(currencySymbol, isNew);
  const { icon, typeLabel, extraFields } = getOrderCardContent(
    order.order_type,
    orderParams,
    order.data
  );

  return (
    <div
      className={`${styles.orderCard}
       ${isNew ? styles.new : styles.default}
       ${order.status === OrderStatus.PENDING && styles.pendingCard}
       `}
      onClick={() => onSelect(order)}
    >
      <div className={styles.topRow}>
        <div className={styles.leftSide}>
          {icon}
          <div className={styles.mainInfo}>
            <h3 className={isNew ? styles.typeLabelNew : styles.typeLabel}>{typeLabel}</h3>
            <p className={isNew ? styles.dateNew : styles.date}>{formatDate(order.created_at!)}</p>
            <div className={styles.phoneRow}>
              <PhoneIcon width={15} height={20} />
              <p className={isNew ? styles.phoneNew : styles.phone}>{orderParams.phone_number}</p>
            </div>
          </div>
        </div>
        <div className={isNew ? styles.newStatusBox : styles.statusBox}>
          <OrderStatusBadge
            status={order.status}
            onClick={
              order.status !== OrderStatus.NEW
                ? () => onOpenStatusDialog(order)
                : undefined
            }
          />
        </div>
      </div>

      <div className={styles.middleSide}>{extraFields}</div>
    </div>
  );
};

export default CompanyOrderCard;
